var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtendTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.625 55.25C53.625 51.7351 51.9805 48.4331 49.2537 46.2946C49.9476 45.0986 50.375 43.7288 50.375 42.25V39C50.375 34.5199 46.7301 30.875 42.25 30.875C37.7699 30.875 34.125 34.5199 34.125 39V42.25C34.125 43.7288 34.5524 45.0986 35.2446 46.2946C32.5195 48.4331 30.875 51.7367 30.875 55.25V58.5H53.625V55.25ZM37.375 39C37.375 36.3123 39.5623 34.125 42.25 34.125C44.9377 34.125 47.125 36.3123 47.125 39V42.25C47.125 44.9377 44.9377 47.125 42.25 47.125C39.5623 47.125 37.375 44.9377 37.375 42.25V39ZM34.125 55.25C34.125 52.6744 35.3649 50.258 37.4075 48.7354C38.7644 49.751 40.4284 50.375 42.25 50.375C44.0716 50.375 45.7372 49.751 47.0925 48.7354C49.1351 50.258 50.375 52.6728 50.375 55.25H34.125Z",
    fill: "#FBF9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.375 30.875H60.125V34.125H76.375V30.875Z",
    fill: "#FBF9EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.375 37.375H60.125V40.625H76.375V37.375Z",
    fill: "#FBF9EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.125 43.875H60.125V47.125H73.125V43.875Z",
    fill: "#FBF9EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.875 50.375H60.125V53.625H69.875V50.375Z",
    fill: "#FBF9EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 65H30.875V68.25H42.25V65Z",
    fill: "#FBF9EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 71.5H30.875V74.75H42.25V71.5Z",
    fill: "#FBF9EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 78H30.875V81.25H42.25V78Z",
    fill: "#FBF9EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.125 65H45.5V68.25H60.125V65Z",
    fill: "#FBF9EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.125 71.5H45.5V74.75H60.125V71.5Z",
    fill: "#FBF9EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.125 78H45.5V81.25H60.125V78Z",
    fill: "#FBF9EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 19.5H82.576C81.9033 17.6134 80.1158 16.25 78 16.25H59.9609C59.2052 12.5466 55.9227 9.75 52 9.75C48.0773 9.75 44.7948 12.5466 44.0391 16.25H26C23.8842 16.25 22.0967 17.6134 21.424 19.5H19.5C16.8122 19.5 14.625 21.6873 14.625 24.375V86.125C14.625 88.8128 16.8122 91 19.5 91H21.424C22.0967 92.8866 23.8842 94.25 26 94.25H78C80.1158 94.25 81.9033 92.8866 82.576 91H84.5C87.1878 91 89.375 88.8128 89.375 86.125V24.375C89.375 21.6873 87.1878 19.5 84.5 19.5ZM47.125 17.875C47.125 15.1873 49.3122 13 52 13C54.6878 13 56.875 15.1873 56.875 17.875V22.75H47.125V17.875ZM17.875 86.125V24.375C17.875 23.4796 18.603 22.75 19.5 22.75H21.125V87.75H19.5C18.603 87.75 17.875 87.0204 17.875 86.125ZM79.625 89.375C79.625 90.2704 78.897 91 78 91H26C25.103 91 24.375 90.2704 24.375 89.375V21.125C24.375 20.2296 25.103 19.5 26 19.5H43.875V26H60.125V19.5H78C78.897 19.5 79.625 20.2296 79.625 21.125V89.375ZM86.125 86.125C86.125 87.0204 85.397 87.75 84.5 87.75H82.875V22.75H84.5C85.397 22.75 86.125 23.4796 86.125 24.375V86.125Z",
    fill: "#FBF9EB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.125 17.875C47.125 15.1873 49.3122 13 52 13C54.6878 13 56.875 15.1873 56.875 17.875V22.75H47.125V17.875Z",
    fill: "#FBF9EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.75 81.25H65C64.103 81.25 63.375 80.522 63.375 79.625V66.625C63.375 65.728 64.103 65 65 65H74.75C75.647 65 76.375 65.728 76.375 66.625V79.625C76.375 80.522 75.647 81.25 74.75 81.25Z",
    fill: "#FBF9EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendTeam);
export default __webpack_public_path__ + "static/media/extend-team.e0d411728ab8d423c72572a9cd60d91b.svg";
export { ForwardRef as ReactComponent };